import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47a5.57 5.57 0 0 1-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
    <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A11.99 11.99 0 0 0 12 24z" />
    <path fill="#FBBC05" d="M5.27 14.29A7.15 7.15 0 0 1 4.89 12c0-.8.14-1.57.38-2.29V6.62H1.29a12.01 12.01 0 0 0 0 10.76l3.98-3.09z" />
    <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.69 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
  </svg>
);

export default function GoogleButton({ label = "Continuar con Google", compact = false }) {
  const { login, loggingIn } = useAuth();
  return (
    <button
      data-testid="login-button"
      onClick={login}
      disabled={loggingIn}
      className={`inline-flex items-center justify-center gap-2.5 bg-white text-gray-700 font-semibold rounded-xl border border-gray-300 hover:border-purple-400 hover:shadow-md transition-all disabled:opacity-60 ${compact ? "px-2.5 sm:px-4 py-2 text-xs sm:text-sm whitespace-nowrap gap-1.5 sm:gap-2.5" : "px-5 py-2.5 text-sm"}`}
    >
      {loggingIn ? <Loader2 className="w-[18px] h-[18px] animate-spin text-purple-600" /> : <GoogleIcon />}
      {loggingIn ? "Conectando..." : label}
    </button>
  );
}
